import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { openModal } from '../../actions/ui_actions';
import { modalTypes as MODAL_TYPES } from '../../constants/modalTypes';
import flipIcon from '../../assets/flip-icon.svg';

import { MONTHS } from '../../constants';


const mapStateToProps = (state, ownProps) => ({
  loggedIn: !!state.session.currentUser,
  postOptionsModalOpen: !!state.ui.modals.postOptionsModal,
  currUserIsAuthor: (
    !!state.session.currentUser
    && state.session.currentUser.username === ownProps.username
  ),
});

const mapDispatchToProps = dispatch => ({
  openPostOptionsModal: postId => dispatch(openModal(MODAL_TYPES.POST_OPTIONS_MODAL, postId)),
  openAuthorOptionsModal: postId => dispatch(openModal(MODAL_TYPES.AUTHOR_OPTIONS_MODAL, postId)),
});


const PostHeader = (props) => {
  let dateMessage = ``;
  const postD = new Date(props.postTimestamp);
  const today = new Date ();
  const postYear = postD.getFullYear ();
  const postDate = postD.getDate ();
  const postMonth = postD.getMonth ();
  if (postYear === today.getFullYear () && postMonth === today.getMonth () && postDate === today.getDate ()) {
    dateMessage = postD.getHours () > 16 ? 'Tonight' : 'Today';
  } else {
    dateMessage = `${MONTHS[postMonth]} ${postDate}`
    if (postYear !== today.getFullYear ()) dateMessage += `, ${postYear}`
  }

  return (
    <div className="post-header">
      <div className="post-author">
        <h3>
        <Link to={`/event/${props.postId}`}>
          {props.postTitle}
        </Link>
        </h3>
      </div>
      <div className="post-date transparent-text">
        <span>{dateMessage}</span>
      </div>
      {/* <div role="button" onClick={() => { props.toggleDetailView() }}>
        <img className="flip-icon" src={flipIcon} alt="flip to post detail view" />
      </div> */}
      {/* @@TODO WHY IS THIS IN THE DOM? */}
      {/* {props.loggedIn} */}
    </div>
  );
};

PostHeader.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
  postId: PropTypes.number.isRequired,
  postTitle: PropTypes.string.isRequired,
  postTimestamp: PropTypes.string.isRequired,
  toggleDetailView: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostHeader);
